import {apiClient as client} from '@/shared/service/api-client';

export default {
  async search(params) {
    return await client.get('/sendCustomerMessage/search', {params: params});
},
  async getBase(params){
    return await client.get('/sendCustomerMessage/getBase', {params: params});
  },
  async getCustomerFilter(params){
    return await client.get('/sendCustomerMessage/getCustomerFilter', {params: params});
  },
  async getStaffList(params){
    return await client.get('/sendCustomerMessage/getStaffList', {params: params});
  },
  async getUrlBaseInfo(params){
    return await client.get('/sendCustomerMessage/getUrlBaseInfo', {params: params});
  },
  async create(params) {
    return await client.post('/sendCustomerMessage/create', params);
  },
  async sendNotice(id) {
    return await client.post('/sendCustomerMessage/sendNotice', {id: id});
  },
  async getSendCustomerCnt(params) {
    return await client.post('/sendCustomerMessage/getSendCustomerCnt', params);
  },
  async uploadImg(params) {
    return await client.post('/sendCustomerMessage/uploadWorkWechatImg', params);
  },
}
